// extracted by mini-css-extract-plugin
module.exports = {"rightSidebar":"styles_rightSidebar__1_OBW"};